import {
    CheckCircle2,
    Clock3,
} from "lucide-react";

import "./TimelineTab.css";

function TimelineTab({ order }) {

    const timeline = order.timeline || [];

    return (

        <div className="timeline-tab">

            <h2>Order Timeline</h2>

            {timeline.length === 0 ? (

                <div className="timeline-empty">

                    No timeline available.

                </div>

            ) : (

                <div className="timeline-list">

                    {timeline.map((event, index) => (

                        <div
                            className="timeline-item"
                            key={index}
                        >

                            <div className="timeline-icon">

                                <CheckCircle2 size={20} />

                            </div>

                            <div className="timeline-content">

                                <h4>

                                    {event.status}

                                </h4>

                                <p>

                                    {event.note || "-"}

                                </p>

                                <small>

                                    <Clock3 size={14} />

                                    {new Date(
                                        event.time
                                    ).toLocaleString()}

                                </small>

                            </div>

                        </div>

                    ))}

                </div>

            )}

        </div>

    );

}

export default TimelineTab;